"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderType = void 0;
const React = require("react");
const Icon_1 = require("../../../../../components/base/atoms/Icon");
const colors_1 = require("../../../../../types/colors");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "OrderType");
const OrderType = ({ orderType }) => {
    const isDelivery = orderType === "delivery";
    const icon = isDelivery ? "delivery" : "pick-up";
    const label = isDelivery ? "Delivery" : "Pick up";
    return (React.createElement("div", { className: css("") },
        React.createElement(Icon_1.Icon, { name: icon, className: css("icon"), variant: colors_1.TColorVariants.Primary }),
        React.createElement("label", null, label)));
};
exports.OrderType = OrderType;
//# sourceMappingURL=index.js.map